


















































































































































import { fromUnixTime, sub, isAfter } from 'date-fns';
import axios from 'axios';
import { get } from 'lodash';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoModal from '../co-modal/CoModal.vue';
import CoTag from '@/components/Atoms/co-tag/CoTag.vue';

export default {
    name: 'CoBookingModal',
    components: {
        CoModal,
        CoText,
        CoThumbnail,
        CoDate,
        CoFormGroup,
        CoLink,
        CoButton,
        CoConfirmation,
        CoTag,
    },
    props: {
        booking: {
            type: Object,
            required: false,
            default: () => {},
        },
        asAdmin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            forUser: null, // user object for whom is booking
            byUser: null, // user object by who was it booked
            loading: false,
        };
    },
    computed: {
        byUserUrl() {
            if (!this.byUser) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/community/member/view/${this.byUser.ID}`;
            }

            return `/profile/${this.byUser.Slug}`;
        },
        forUserUrl() {
            if (!this.forUser) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/community/member/view/${this.forUser.ID}`;
            }

            return `/profile/${this.forUser.Slug}`;
        },
        canCancel() {
            if (!this.booking || this.booking?.Status === 'cancelled') {
                return false;
            }

            if (this.asAdmin) {
                return true;
            }

            const start = fromUnixTime(this.booking.Start);
            const cancelPeriod = start;
            const diff = sub(cancelPeriod, {
                hours: this.booking.Resource.CancellationPeriod,
            });
            let canCancel = true;
            const now = new Date();
            if (isAfter(now, diff)) {
                canCancel = false;
            }

            return canCancel;
        },
        isCanceled() {
            return this.booking?.Status === 'cancelled';
        },
    },
    watch: {
        booking(val) {
            if (val) {
                this.$refs[`bookin-modal`].show();
            } else {
                this.$refs[`bookin-modal`].hide();
            }

            if (this.forUser && this.forUser === val.UserID && val.UserID !== '') {
                // skip loading again
            } else {
                this.forUser = null;
                if (val.UserID) {
                    this.getForUser(val.UserID);
                }
            }
            if (
                this.byUser &&
                this.byUser === val.UserID &&
                val.UserID !== '' &&
                this.forUser &&
                this.byUser.ID === this.forUser.ID
            ) {
                // skip loading again
            } else {
                this.byUser = null;
                if (val.CreatedByUserID) {
                    this.getByUser(val.CreatedByUserID);
                }
            }
        },
    },
    mounted() {
        if (this.booking) {
            this.$refs[`bookin-modal`].show();

            if (this.forUser && this.forUser === this.booking.UserID && this.booking.UserID !== '') {
                // skip loading again
            } else {
                this.forUser = null;
                if (this.booking.UserID) {
                    this.getForUser(this.booking.UserID);
                }
            }
            if (
                this.byUser &&
                this.byUser === this.booking.UserID &&
                this.booking.UserID !== '' &&
                this.forUser &&
                this.byUser.ID === this.forUser.ID
            ) {
                // skip loading again
            } else {
                this.byUser = null;
                if (this.booking.CreatedByUserID) {
                    this.getByUser(this.booking.CreatedByUserID);
                }
            }
        }
    },
    methods: {
        get,
        close() {
            this.$emit('closed');
        },
        getForUser(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.forUser = response;
                    if (get(this.booking, 'CreatedByUserID', '') === this.forUser.ID) {
                        this.byUser = this.forUser;
                    }
                })
                .catch((error) => {});
        },
        getByUser(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.byUser = response;
                })
                .catch((error) => {});
        },
        cancelBooking() {
            let url = `/booking/v2/${this.booking.ID}`;

            if (this.asAdmin) {
                url = `/admin/booking/${this.booking.ID}`;
            }

            this.loading = true;
            axios({
                method: 'DELETE',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$emit('canceled');
                })
                .catch((error) => {
                    this.$emit('failed', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
